/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

// Route helpers for the 2026 redesign, which sits behind UTEST_DESIGN_REFRESH_2026. A state that renders the
// new page or the legacy one resolves `useNewDesign: useNewDesign` and switches on `$resolve.useNewDesign`.

// Depends on `features` so the flags have loaded before they're read.
export const useNewDesign = ['features', 'featureFlags', (features, featureFlags) => featureFlags.isOn('UTEST_DESIGN_REFRESH_2026')];

// A `redirectTo` for states whose target differs by design; null stays put. It carries every param over, so a
// legacy state and its 2026 twin can share a URL. When the URL started the transition, its query is carried too:
// a twin may declare query params (like ?sort) that the legacy state reads from $location instead.
export const redirectByDesign = (stateWhenOn: string | null, stateWhenOff: string | null) => (trans) => (
  trans.injector().getAsync('features').then(() => {
    const target = trans.injector().get('featureFlags').isOn('UTEST_DESIGN_REFRESH_2026') ? stateWhenOn : stateWhenOff;
    if (!target) return undefined;
    const query = trans.options().source === 'url' ? trans.router.urlService.search() : {};
    return { state: target, params: { ...query, ...trans.params() } };
  })
);

// The new pages show the 404 page when the resolved item can't be found. The legacy pages fail the
// transition, as before.
export const notFoundByDesign = (promise, $state, isNewDesign: boolean) => (isNewDesign
  ? promise.catch(() => $state.go('fourohfour', null, { location: false }))
  : promise);
